import { gql } from '@apollo/client';

export const SAVE_NON_WORKING_DAY = gql`
  mutation saveNonWorkingDay($input: SaveNonWorkingDayInput!) {
    saveNonWorkingDay(input: $input) {
      commandId
      correlationId
    }
  }
`;
